import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import ModalAdvanceOptions from "../ModalAdvanceOptions/ModalAdvanceOptions";
import {
  ButtonLink,
  ContentSelectInvite,
  List,
  SelectStylesInvite,
  TextTitleList,
} from "./InviteUsersGroupsComponent.styled";
import PointersLine from "../Loaders/PointersLine/PointersLine";
import Select from "react-select";
import { IconButton, Tooltip } from "@material-ui/core";
import RemoveCircleOutline from "@material-ui/icons/RemoveCircleOutline";
import PersonIcon from "@material-ui/icons/Person";
import InfoIcon from "@mui/icons-material/Info";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import { theme as themeConfig } from "../../themes/themes";

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: themeConfig.text.primary,
    color: "white",
    padding: "1em 0 1em 1rem",
  },
}))(Tooltip);

const InviteUsersGroupsComponent = ({
  showAdvanceOption,
  selectedUsers,
  closeAdvanceSearch,
  allCountries,
  handleChangeSelectCountry,
  rCountries,
  rCities,
  rRoles,
  rLobs,
  allCities,
  handleChangeSelectCity,
  loadingRoleByLevel,
  errorRoleByLevel,
  allRolesByLevel,
  handleChangeSelectRole,
  setSelectedRole,
  allLobs,
  handleChangeSelectLob,
  usersAdvanceSearch,
  createGroup,
  rSelectedUsers,
  guestsData,
  handleChangeSelectUsers,
  cleanSelects,
  individualGuests,
  loadingUsersInRole,
  errorUsersInRole,
  removeUserAsigned,
  groups,
  removeGroupsAsigned,
  columnDisplay = false,
  fieldLabel = "Event users assignation (if private)",
  groupAssignLabel = "Advanced Search",
  mandatory = false,
  showIconFieldLabel = false,
  disabledSelector = false,
  handleChangeComoNoComo,
  rComoNonComo
}) => {


  const modalAdvanceOptions = showAdvanceOption && (
    <ModalAdvanceOptions
      fieldLabel={fieldLabel}
      selectedUsers={selectedUsers}
      closeAdvanceSearch={closeAdvanceSearch}
      allCountries={allCountries}
      handleChangeSelectCountry={handleChangeSelectCountry}
      rCountries={rCountries}
      rCities={rCities}
      rRoles={rRoles}
      rLobs={rLobs}
      allCities={allCities}
      handleChangeSelectCity={handleChangeSelectCity}
      loadingRoleByLevel={loadingRoleByLevel}
      errorRoleByLevel={errorRoleByLevel}
      allRolesByLevel={allRolesByLevel}
      handleChangeSelectRole={handleChangeSelectRole}
      setSelectedRole={setSelectedRole}
      allLobs={allLobs}
      handleChangeSelectLob={handleChangeSelectLob}
      usersAdvanceSearch={usersAdvanceSearch}
      createGroup={createGroup}
      handleChangeComoNoComo={handleChangeComoNoComo}
      rComoNonComo={rComoNonComo}
    />
  );

  return (
    <>
      <Col md={12} className={"my-3"}>
        <ContentSelectInvite users={guestsData}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Form.Label
              style={{ fontWeight: "500", width: "15%", marginBottom: "0" }}
            >
              {showIconFieldLabel && (
                <HtmlTooltip
                  arrow
                  placement="top-start"
                  title="Select all users whose surveys will be approved by the selected approver."
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <InfoIcon style={{ color: themeConfig.neutral.gray[1500] }} />
                    {fieldLabel}
                  </div>
                </HtmlTooltip>
              )}{" "}
              {mandatory && <span style={{ color: "red" }}> *</span>}
            </Form.Label>
            <ButtonLink
              disabledSelector={disabledSelector}
              onClick={() => {
                if (!disabledSelector) {
                  cleanSelects();
                }
              }}
              className="text-right"
            >
              {groupAssignLabel}
            </ButtonLink>
          </div>
          {loadingUsersInRole && (
            <PointersLine color={themeConfig.text.primary}></PointersLine>
          )}
          {!loadingUsersInRole && (
            <Select
              className="w-100 mt-2"
              placeholder="Select an option"
              isMulti
              ref={rSelectedUsers}
              options={guestsData}
              styles={SelectStylesInvite}
              onChange={handleChangeSelectUsers}
              isDisabled={disabledSelector}
              value={individualGuests}
            />
          )}
        </ContentSelectInvite>
      </Col>
      {columnDisplay && (
        <div>
          <Col md={12} className="my-3">
            {individualGuests?.length > 0 &&
              !loadingUsersInRole &&
              !errorUsersInRole && (
                <List className="w-100">
                  <TextTitleList className="font-weight-bold mt-4">
                    Users
                  </TextTitleList>

                  {individualGuests.map((item, index) => <Row key={index}>
                    <Col
                      md="8"
                      className="d-flex align-items-center"
                      style={{ fontSize: "13px" }}
                    >
                      <PersonIcon
                        style={{ color: themeConfig.neutral.gray[2600], marginRight: "10px" }}
                      />{" "}
                      {item.name ? item.name : item.label}
                    </Col>
                    <Col md="4" className="d-flex justify-content-center">
                      <Tooltip title="Remove">
                        <IconButton
                          onClick={() => removeUserAsigned(index, item)}
                        >
                          <RemoveCircleOutline
                            style={{ color: themeConfig.status.errorDark }}
                          />
                        </IconButton>
                      </Tooltip>
                    </Col>
                  </Row>)}
                </List>
              )}
          </Col>
          <Col md={12} className="my-3">
            {groups?.length > 0 && (
              <List className="w-100">
                <TextTitleList className="font-weight-bold mt-4">
                  Groups
                </TextTitleList>
                {groups.map((item, index) => <Row key={index}>
                  <Col
                    md="8"
                    className="d-flex align-items-center"
                    style={{ fontSize: "13px" }}
                  >
                    <PersonIcon
                      style={{ color: themeConfig.neutral.gray[2600], marginRight: "10px" }}
                    />
                    {item.name ? item.name : item.groupName}
                  </Col>
                  <Col md="4" className="d-flex justify-content-center">
                    <Tooltip title="Remove">
                      <IconButton
                        onClick={() => removeGroupsAsigned(index, item)}
                      >
                        <RemoveCircleOutline
                          style={{ color: themeConfig.status.errorDark }}
                        />
                      </IconButton>
                    </Tooltip>
                  </Col>
                </Row>)}
              </List>
            )}
          </Col>
        </div>
      )}
      {!columnDisplay && (
        <>
          <Col md={12} className="my-3">
            {individualGuests?.length > 0 &&
              !loadingUsersInRole &&
              !errorUsersInRole && (
                <List className="w-100">
                  <TextTitleList className="font-weight-bold mt-4">
                    Users
                  </TextTitleList>

                  {individualGuests.map((item, index) => <Row key={index}>
                    <Col
                      md="8"
                      className="d-flex align-items-center"
                      style={{ fontSize: "13px" }}
                    >
                      {index + 1}. {item.name ? item.name : item.label}
                    </Col>
                    <Col md="4" className="d-flex justify-content-center">
                      <Tooltip title="Remove">
                        <IconButton
                          onClick={() => removeUserAsigned(index, item)}
                        >
                          <RemoveCircleOutline
                            style={{ color: themeConfig.text.primary }}
                          />
                        </IconButton>
                      </Tooltip>
                    </Col>
                  </Row>)}
                </List>
              )}
          </Col>
          <Col md={12} className="my-3">
            {groups?.length > 0 && (
              <List className="w-100">
                <TextTitleList className="font-weight-bold mt-4">
                  Groups
                </TextTitleList>
                {groups.map((item, index) => <Row key={index}>
                  <Col
                    md="8"
                    className="d-flex align-items-center"
                    style={{ fontSize: "13px" }}
                  >
                    {index + 1}. {item.name ? item.name : item.groupName}
                  </Col>
                  <Col md="4" className="d-flex justify-content-center">
                    <Tooltip title="Remove">
                      <IconButton
                        onClick={() => removeGroupsAsigned(index, item)}
                      >
                        <RemoveCircleOutline
                          style={{ color: themeConfig.text.primary }}
                        />
                      </IconButton>
                    </Tooltip>
                  </Col>
                </Row>)}
              </List>
            )}
          </Col>
        </>
      )}
      {modalAdvanceOptions}
    </>
  );
};

InviteUsersGroupsComponent.propTypes = {
  showAdvanceOption: PropTypes.bool,
  selectedUsers: PropTypes.array,
  closeAdvanceSearch: PropTypes.func,
  allCountries: PropTypes.array,
  handleChangeSelectCountry: PropTypes.func,
  rCountries: PropTypes.shape({
    current: PropTypes.instanceOf(Element),
  }),
  rCities: PropTypes.shape({
    current: PropTypes.instanceOf(Element),
  }),
  rRoles: PropTypes.shape({
    current: PropTypes.instanceOf(Element),
  }),
  rLobs: PropTypes.shape({
    current: PropTypes.instanceOf(Element),
  }),
  allCities: PropTypes.array,
  handleChangeSelectCity: PropTypes.func,
  loadingRoleByLevel: PropTypes.bool,
  errorRoleByLevel: PropTypes.bool,
  allRolesByLevel: PropTypes.array,
  handleChangeSelectRole: PropTypes.func,
  setSelectedRole: PropTypes.func,
  allLobs: PropTypes.array,
  handleChangeSelectLob: PropTypes.func,
  usersAdvanceSearch: PropTypes.array,
  createGroup: PropTypes.func,
  rSelectedUsers: PropTypes.shape({
    current: PropTypes.instanceOf(Element),
  }),
  guestsData: PropTypes.array,
  handleChangeSelectUsers: PropTypes.func,
  cleanSelects: PropTypes.func,
  individualGuests: PropTypes.array,
  loadingUsersInRole: PropTypes.bool,
  errorUsersInRole: PropTypes.bool,
  removeUserAsigned: PropTypes.func,
  groups: PropTypes.array,
  removeGroupsAsigned: PropTypes.func,
  columnDisplay: PropTypes.bool,
  fieldLabel: PropTypes.string,
  groupAssignLabel: PropTypes.string,
  mandatory: PropTypes.bool,
  showIconFieldLabel: PropTypes.bool,
  disabledSelector: PropTypes.bool,
  handleChangeComoNoComo: PropTypes.func,
  rComoNonComo: PropTypes.shape({
    current: PropTypes.instanceOf(Element),
  }),
}

export default InviteUsersGroupsComponent;
